const linkToFeatureMap = {}
const featureLists = []

const mappingFunction = (pathFeatureComponentArray)=>{
    pathFeatureComponentArray.map((object)=>{
        featureLists.push({path:object.path,feature:object.feature})
        return linkToFeatureMap[object?.feature] = object?.path;
    })
}

export  {linkToFeatureMap,featureLists, mappingFunction};